export default __webpack_public_path__ + "static/media/ma.0412c4b5.svg";